import { createSlice } from '@reduxjs/toolkit';

const initialState = {
	unpaidFirstPaymentList: {},
	leadsInProgress: [],
	campaignsNearingTheEnd: [],
	campaignsNearingTheEndManager: [],
	campaignsNearingTheEndContactRelease: [],
	escalationBasic: [],
	escalationSummary: [],
	leadsToProcess: [],
};

export const dashboardTodaysUrgencies = createSlice({
	name: 'dashboard-todaysUrgencies',
	initialState,
	reducers: {
		setUnpaidFirstPayment: (state, { payload }) => ({
			...state,
			unpaidFirstPaymentList: {
				...state.unpaidFirstPaymentList,
				...payload,
			},
		}),
		setLeadsInProgress: (state, { payload }) => ({
			...state,
			leadsInProgress: payload,
		}),
		setCampaignsNearingTheEnd: (state, { payload }) => ({
			...state,
			campaignsNearingTheEnd: payload,
		}),
		setEscalationBasic: (state, { payload }) => ({
			...state,
			escalationBasic: payload,
		}),
		setEscalationSummary: (state, { payload }) => ({
			...state,
			escalationSummary: payload,
		}),
		setCampaignsNearingTheEndManager: (state, { payload }) => ({
			...state,
			campaignsNearingTheEndManager: payload,
		}),
		setCampaignsNearingTheEndContactRelease: (state, { payload }) => ({
			...state,
			campaignsNearingTheEndContactRelease: payload,
		}),
		setLeadsToProcess: (state, { payload }) => ({
			...state,
			leadsToProcess: payload,
		}),
		reset: () => initialState,
	},
});

export default dashboardTodaysUrgencies.reducer;
export const REDUCER_NAME = dashboardTodaysUrgencies.name;

export const {
	setUnpaidFirstPayment,
	setLeadsInProgress,
	setCampaignsNearingTheEnd,
	setEscalationBasic,
	setEscalationSummary,
	setCampaignsNearingTheEndManager,
	setCampaignsNearingTheEndContactRelease,
	setLeadsToProcess,
	reset,
} = dashboardTodaysUrgencies.actions;
